import { render, staticRenderFns } from "./GogoPortalRuntimeRouterView.vue?vue&type=template&id=536bd5b0&scoped=true"
import script from "./GogoPortalRuntimeRouterView.vue?vue&type=script&lang=ts"
export * from "./GogoPortalRuntimeRouterView.vue?vue&type=script&lang=ts"
import style0 from "./GogoPortalRuntimeRouterView.vue?vue&type=style&index=0&id=536bd5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536bd5b0",
  null
  
)

export default component.exports